<ng-container *ngIf="hasAccess; else accessDenied">
	<router-outlet></router-outlet>
</ng-container>
<ng-template #accessDenied>
	<app-access-denied></app-access-denied>
</ng-template>